export class HojaRutaFilter {
  gestion?: number;
  numero?: number;
  fecha?: Date;
  estado?: string;
}
